import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4b7751c5"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/卡百利业务中台2.0（前端）生产环境/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b7751c5')) {
      api.createRecord('4b7751c5', component.options)
    } else {
      api.reload('4b7751c5', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4b7751c5", function () {
      api.rerender('4b7751c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/components/VabRemind/index.vue"
export default component.exports